import {action, computed, observable, runInAction} from 'mobx'
import {message} from 'antd'
import {json} from '../../../../utils/ajax'
import {isAuthenticated} from '../../../../utils/Session'
import {setStore} from "../../../../utils/Utils";

class BoutiqueGoodsStore {

    @observable loading
    @observable typeCatalog//用于放分类（目录树）
    @observable typeCatalogId//获取到分类（目录树）ID
    @observable pagination//用于分页
    @observable goods//用于获取内容
    @observable goodsAndGoodsAttrForms//平行化表单，传值给form
    @observable attr//用于获取初始化属性
    @observable fileList//用于获取图片路径
    @observable firstIndexId//用于获取到属性ID
    @observable currentIndex//用于点击Button时获取到属性ID
    @observable contentInfoList//用于初始化属性
    @observable level//用于获取层级
    @observable carList   //车系列表
    @observable newCarseriesIdList   //用来存放最新的勾选车系数组
    @observable carNameList
    @observable carInfoList
    @observable newCarseriesId
    @observable isShow   //判断是否显示
    @observable status        //判断是修改还是新增的显示状态
    @observable expandedKeysArr   //展开的节点
    @observable expandedKeysSel   //展开的高亮的节点
    @observable expandedKeysArr1
    @observable indeterminate  //控制全选样式
    @observable firstData    //回显的第一个值
    @observable generalState   //判断是否勾选了通用选项
    @observable currentGoodsId   //点击修改时当前点击的商品id
    @observable rowData

    constructor() {
        this.loading = false
        this.typeCatalog = []
        this.typeCatalogId = 0
        this.pagination = {
            current: 0,
            total: 1
        }
        this.goods = []
        this.goodsAndGoodsAttrForms = {
            name: '',
            code: '',
            words: '',
            carseries: '',
            imgUrl: '',
            boutiqueGoodsImgs: [],
            boutiqueGoodsAttrs: [],
            carId: "",
            generalState: ''
        }
        this.attr = []
        this.fileList = []
        this.firstIndexId = 0
        this.currentIndex = 0
        this.contentInfoList = []
        this.level = 0
        this.carList = []
        this.newCarseriesIdList = []
        this.carNameList = []
        this.carInfoList = []
        this.newCarseriesId = ''
        this.isShow = false
        this.status = false
        this.expandedKeysArr = []
        this.expandedKeysSel = []
        this.expandedKeysArr1 = []
        this.indeterminate = true
        this.firstData = ''
        this.generalState = ''
        this.currentGoodsId = ''
        this.rowData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 每次进入商品页面时都清掉Level
     * Level是用来判断点击2级目录是显示商品列表用的
     */
    @action
    resetLevel = () => {
        runInAction(() => {
            this.level = 0
        })
    }

    /**
     * 初始化分类（目录树）
     */
    @action
    initTypeCatalog = async () => {
        runInAction(() => {
            this.isShow = false
            this.loading = true
            this.expandedKeysSel = []
            this.expandedKeysArr = []
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/catalogTreeList`)
        runInAction(() => {
            if (res.length === 0) {
                this.loading = false
                return
            }
            this.typeCatalog = Array.isArray(res) ? res : []  //用于存放所有接口查出来的分类（目录树）结构
            this.loading = false
        })
    }

    /**
     * 获取到分类(目录树)ID
     */
    @action
    gainTypeId = (typeId) => {
        runInAction(() => {
            this.expandedKeysSel = []
            this.typeCatalogId = typeId//获取到分类（目录树）的第一个ID
            this.expandedKeysSel.push(typeId)
        })
    }

    /**
     * 显示商品列表
     */
    @action
    loadTypeContents = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        //用来查询商品列表+分页
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/type/id/${this.typeCatalogId}`, {
            page: page
        })
        if (res.status && res.status === 0) {
            this.loading = false
            return
        }
        //用来拿到所有的层级
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/get/${this.typeCatalogId}`)
        if (res1.status && res1.status === 0) {
            return
        }
        runInAction(() => {
            this.goods = res.content//用于存放（第一个请求）查询出来的所有商品
            this.level = res1.level//用于存放（第二个请求）查询出来的层级
            //用于分页
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 添加商品及商品属性
     * 平行化表单，传值给form
     */
    @computed
    get goodsAndGoodsAttrFields() {
        let goodsAndGoodsAttrFields = {
            name: {value: this.goodsAndGoodsAttrForms.name},
            code: {value: this.goodsAndGoodsAttrForms.code},
            words: {value: this.goodsAndGoodsAttrForms.words},
            boutiqueDescription: {value: this.goodsAndGoodsAttrForms.boutiqueDescription},
            carseries: {value: this.goodsAndGoodsAttrForms.carseries},
            imgUrl: {value: this.goodsAndGoodsAttrForms.imgUrl},
            boutiqueGoodsImgs: {value: this.goodsAndGoodsAttrForms.boutiqueGoodsImgs.map(item => item.url)},
        }
        this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs.forEach((item, index) => {
            goodsAndGoodsAttrFields[`attrItemText-${index}`] = {value: `${item.attrItemText}`}
            goodsAndGoodsAttrFields[`attrItemImg-${index}`] = {value: `${item.attrItemImg}`}
        })
        return goodsAndGoodsAttrFields
    }

    /**
     * 添加商品及商品属性
     * 将表单时对象化，绑值给store。form
     */
    @action
    onGoodsAndGoodsAttrChange = (values) => {
        //要是values里有imgUrl或者boutiqueGoodsImgs就return
        if (values.imgUrl || values.boutiqueGoodsImgs) {
            return
        }
        //attr长度大于0的话就把attrItemImg-${i}的值return出去
        for (let i = 0; i < this.attr.length; i++) {
            if (values[`attrItemImg-${i}`]) {
                return
            }
        }
        /**
         * 循环是看属性里有没有值，要是没有值就传一个属性ID到后台，内容则是空。
         * 要是有值就把属性ID和内容一起传到后台。
         */
        for (let i = 0; i < this.attr.length; i++) {
            if (values[`attrItemText-${i}`]) {
                //判断goodsAndGoodsAttrForms中的boutiqueGoodsAttrs长度是否小于attr的长度
                if (this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs.length < this.attr.length) {
                    //把attr.map里面循环获取到的值赋给this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs
                    this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs = this.attr.map((item, index) => {
                        //要是index等于i的话就return出（attrId和attrItemText）
                        if (index === i) {
                            return {attrId: item.id, attrItemText: values[`attrItemText-${i}`]}
                        } else {
                            //要是index不等于i的话就return出（attrId）
                            return {attrId: item.id}
                        }
                    })
                    return
                } else {
                    //要是goodsAndGoodsAttrForms中的boutiqueGoodsAttrs长度大于attr的长度就直接返回attrItemText里面的值
                    this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs[i] = {
                        ...this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs[i],
                        attrItemText: values[`attrItemText-${i}`]
                    }
                    return
                }
            }
        }
        this.goodsAndGoodsAttrForms = {
            ...this.goodsAndGoodsAttrForms,
            ...values
        }
    }

    /**
     * 单图上传
     */
    @action
    uploadMainImage = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            runInAction(() => {
                //拿到图片路径
                this.goodsAndGoodsAttrForms = {...this.goodsAndGoodsAttrForms, imgUrl: info.file.response}
                this.loading = false
            })
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 上传失败`)
            runInAction(() => {
                this.loading = false
            })
        }
    }

    // /**
    //  * 多图上传
    //  */
    // @action imageUpload = (info, field) => {
    //     const form = {...this.goodsAndGoodsAttrForms}
    //     //循环fileList，要是里面有图片就返回原有的，要是没有就返回一个url = item.response（拿到图片路径给url）
    //     form[field] = info.fileList.map(item => {
    //         if (item.id) {
    //             return item
    //         } else {
    //             return {url: item.response}
    //         }
    //     })
    //     runInAction(() => {
    //         this.goodsAndGoodsAttrForms = form
    //         console.log(this.goodsAndGoodsAttrForms,'this.goodsAndGoodsAttrForms')
    //     })
    // }
    /**
     * 多图上传
     */
    @action imageUpload = (info, field) => {
        const form = {...this.goodsAndGoodsAttrForms}
        //循环fileList，要是里面有图片就返回原有的，要是没有就返回一个url = item.response（拿到图片路径给url）
        form[field] = info.fileList.map(item => {
           if (item.response) {
                return {url: item.response}
            } else if (item.url) {
                return {url: item.url}
            } else {
                return null
            }
        })
        runInAction(() => {
            if (form.boutiqueGoodsImgs[0] !== null) {
                this.goodsAndGoodsAttrForms = form
            } else {
                form.boutiqueGoodsImgs = []
                this.goodsAndGoodsAttrForms = form
            }
        })
    }

    /**
     * 循环里的多图上传
     */
    @action attrImageUpload = (info, index) => {
        /**
         * 判断goodsAndGoodsAttrForms中的boutiqueGoodsAttrs长度是否小于attr的长度
         * 要是小于attr长度就return（返回）attrId
         * 这个判断是用于属性attr里面上传图片用的~~~要是图片属性为空就返回属性ID~~~
         */
        if (this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs.length < this.attr.length) {
            this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs = this.attr.map(item => {
                return {attrId: item.id}
            })
        }
        /**
         * 要是有图片要上传就执行下面的fileList
         * fileList会出现两种情况一个是有ID的一个是没有ID的~~~
         * 要是有ID就直接返回url~~~
         * 要是没有ID就返回一个item.response图片路径
         */
        const fileList = info.fileList.map(item => {
            if (item.id) {
                return item.url
            } else {
                return item.response
            }
        })
        /**
         * 因为是多张图片一起传到后台，而后台是一个一段接收多张图
         * 所以这里做了处理，把多张图片路径放到一起中间用逗号（，）区分。
         */
        this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs[index] = {
            ...this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs[index],
            attrItemImg: fileList.join(',')
        }
    }

    /**
     * 新增/修改
     */
    @action saveGoodsAndGoodsAttr = async () => {
        // /**
        //  * 点击保存时把params传过来,params里面有两个值。
        //  * 用params.id是否为none，要是等于none就执行新增。
        //  * 要是params.id不为none，就执行修改。
        //  */
        // if (this.goodsAndGoodsAttrForms.carseries.length <= 0) {
        //     return message.warn('最少勾选一个')
        // }
        if (this.goodsAndGoodsAttrForms.carseries.length>=1) {
            this.goodsAndGoodsAttrForms.carseries.map(item => {
                this.carList.map(item1 => {
                    if (item === item1 && Array.isArray(this.newCarseriesIdList)) {
                        this.newCarseriesIdList.push(item)
                    }
                })
            })
        }
        let arr = []
        this.newCarseriesIdList.map(i => {
            this.carInfoList.map(j => {
                if (i === j.carseriesName) {
                    arr.push(j.carseriesId)
                    this.newCarseriesId = arr.join(",")
                }
            })
        })
        this.newCarseriesIdList = this.newCarseriesIdList.join(",")
        this.goodsAndGoodsAttrForms.carseries = this.newCarseriesIdList
        this.goodsAndGoodsAttrForms.carId = this.goodsAndGoodsAttrForms.carseries===''?'':this.newCarseriesId
        this.goodsAndGoodsAttrForms.generalState = this.generalState === '' ? 0 : this.generalState
        if (this.currentGoodsId === 'none') {
            runInAction(() => {
                this.loading = true
                this.goodsAndGoodsAttrForms.typeId = this.typeCatalogId
            })
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/add`, this.goodsAndGoodsAttrForms)
            runInAction(() => {
                if (res && res.status === 0) {
                    this.loading = false
                    return
                }
                this.loading = false
                this.typeCatalogId ? this.loadTypeContents() : ''
                this.newCarseriesIdList = []
                this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs.map(i => {
                    i.attrItemText = ''
                    return i
                })
                this.expandedKeysSel.push(this.typeCatalogId)
                this.expandedKeysArr = this.expandedKeysArr1
                this.loadTypeContents()
                this.isShow = true
            })
        } else {
            runInAction(() => {
                this.loading = true
                this.goodsAndGoodsAttrForms.typeId = this.typeCatalogId
                this.goodsAndGoodsAttrForms.id = this.currentGoodsId
            })
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/update`, this.goodsAndGoodsAttrForms)
            runInAction(() => {
                this.loading = false
                this.typeCatalogId ? this.loadTypeContents() : ''
                this.newCarseriesIdList = []
                this.expandedKeysSel.push(this.typeCatalogId)
                this.expandedKeysArr = this.expandedKeysArr1
                this.loadTypeContents()
                this.isShow = true
            })
        }
    }

    /**
     * 初始化属性
     */
    @action
    initAttr = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/attr/attrList`)
        if (res.length === 0) {
            this.loading = false
            return
        }
        /**
         * 下面都是Link到一个新页面是所做的初始化
         * 因为里面都是动态加载的属性名称，所有不管属性里面填不填值都有属性ID
         * 这样好做循环和对比，也方便修改
         */
        runInAction(() => {
            this.attr = res//attr用于存放（请求）查询出来的所有属性
            //contentInfoList用于存放（请求）查询出来的filter里面的item.field值等于4
            this.contentInfoList = res.filter(item => {
                return (
                    item.field === 4
                )
            })
            //循环给this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs里面初始化attrId
            this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs = res.map(item => {
                return {attrId: item.id}
            })
            if (this.contentInfoList[0]) {
                this.firstIndexId = this.contentInfoList[0].id//firstIndexId用于存放获取到第一个属性ID
                this.currentIndex = this.contentInfoList[0].id//currentIndex用于存放点击Button时获取到第一个属性ID
                this.loading = false
            }
            this.loading = false
        })
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    /**
     * 删除
     */
    @action
    deleteGoodsId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/delete?id=${id}`)
        if (res && res.status === 0) {
            this.loading = false
            return
        }
        if (this.goods.length === 1) {
            await this.loadTypeContents(this.pagination.page - 1)
        } else {
            await this.loadTypeContents(this.pagination.page)
        }
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 初始化商品和商品属性，可以不传参数，初始化全部为 null
     * 根据id查询
     */
    @action initGoodsAndGoodsAttr = async (id, e) => {
        this.loading = true
        let carId = ''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/${id}/${carId}`)
        /**
         * 通过商品ID查询出商品的属性，并将查询出来的属性赋给goodsAndGoodsAttrForms以便于回显数据
         */
        runInAction(() => {
            if (res && res.status === 0) {
                this.loading = false
                return
            }
            res.carseriesId.map(i => {
                this.carInfoList.map(j => {
                    if (i === j.carseriesId) {
                        this.carNameList.push(j.carseriesName)
                        return this.carNameList
                    }
                })
            })
            this.generalState = res.generalState
            this.goodsAndGoodsAttrForms = {
                name: res.name,
                code: res.code,
                words: res.words,
                boutiqueDescription: res.boutiqueDescription ? res.boutiqueDescription : '',
                carseries: res.carseries.split(","),
                imgUrl: res.imgUrl,
                boutiqueGoodsImgs: res.boutiqueGoodsImgs,
                boutiqueGoodsAttrs: res.boutiqueGoodsAttrs,
            }
            /**
             * contentInfoList循环用于回显富文本编辑器里的内容
             * boutiqueGoodsAttrs过滤以后要是attrId等于id的话就返回里面的attrItemText，要是没有这个ID就返回原来的item
             * 富文本编辑框也是动态的~~所以这里要循环作对比~~~不然回显不了
             */
            this.contentInfoList = this.contentInfoList.map(item => {
                const list = res.boutiqueGoodsAttrs.filter(it => it.attrId === item.id)
                if (list.length > 0 && list[0].attrItemText !== '') {
                    return {...item, content: list[0].attrItemText}
                } else {
                    return item
                }
            })
            if (this.contentInfoList.length > 0) {
                this.firstData = this.contentInfoList[0].content ? this.contentInfoList[0].content : ''
            }
            this.loading = false
        })
        this.loading = false
    }

    /**
     * 发布/撤销
     */
    @action
    publishByCarseriesId = async (rocord) => {
        runInAction(() => {
            this.loading = true
        })
        let state = rocord.state ? 0 : 1;
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/goods/${rocord.id}/state/${state}`)
        if (res && res.status === 0) {
            message.error('发布失败！');
            this.loading = false
            return
        }
        if (state === 1) {
            message.success('发布成功！');
        } else {
            message.success('撤销成功！');
        }
        runInAction(() => {
            this.loading = false
        })
        this.loadTypeContents(this.page)
    }

    /**
     * 保存content
     */
    @action setFormsContents = (content, id) => {
        //循环contentInfoList要是item.id等于点击Button的ID的话就return（返回）content，不然就return（返回）item
        this.contentInfoList = this.contentInfoList.map(item => {
            if (item.id === id) {
                return {...item, content}
            }
            return item
        })
        /**
         * 循环this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs要是item.attrId等于点击Button的ID的话
         * 就把content放到attrItemText里并return（返回）出去，
         * 不然就return（返回）item
         */
        this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs = this.goodsAndGoodsAttrForms.boutiqueGoodsAttrs.map(item => {
            if (item.attrId === id) {
                return {...item, attrItemText: content}
            }
            return item
        })
    }

    /**
     * 获取到点击Button时的ID
     */
    @action
    setSameId = (id) => {
        runInAction(() => {
            this.currentIndex = id
        })
    }

    /**
     * 每次Link进编辑页面时清空Form
     */
    @action
    initializeForm = () => {
        runInAction(() => {
            this.goodsAndGoodsAttrForms = {
                name: '',
                code: '',
                words: '',
                carseries: '',
                imgUrl: '',
                boutiqueGoodsImgs: [],
                boutiqueGoodsAttrs: [],
                generalState: ''
            }
            this.carList = []
            this.generalState = ''
            this.carNameList = []
            this.contentInfoList = []
        })
    }

    @action
    getCarList = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/carseriesCatalog/carseriesCatalogsList`)
        runInAction(() => {
            this.carInfoList = Array.isArray(res) ? res : []
            if (Array.isArray(res)) {
                res.map(i => {
                    this.carList.push(i.carseriesName)
                })
            }
        })
    }

    @action
    getId = (e) => {
        this.carNameList = e
        this.goodsAndGoodsAttrForms.carseries = this.carNameList
    }

    @action
    changeStatus = () => {
        this.carNameList = this.carList
        this.goodsAndGoodsAttrForms.carseries = this.carNameList
    }

    @action
    noChangeStatus = () => {
        this.carNameList = []
        this.goodsAndGoodsAttrForms.carseries = []
    }

    @action
    changeClick = () => {
        this.indeterminate = false
        this.carList = []
        this.carNameList = []
        this.goodsAndGoodsAttrForms = {
            name: '',
            code: '',
            words: '',
            carseries: '',
            imgUrl: '',
            boutiqueGoodsImgs: [],
            boutiqueGoodsAttrs: [],
            carId: "",
            generalState: ''
        }
    }

    @action
    changeExpands = (arr) => {
        this.expandedKeysArr1 = arr
        this.expandedKeysArr = arr
    }

}

export default new BoutiqueGoodsStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/BoutiqueCatalog/BoutiqueGoods/store.js